import {isResetPasswordPage} from '../shared/utils/common'
;(function() {
  angular.module('app.ui.form.ctrls').controller('ResetPassCtrl', [
    '$http',
    '$log',
    '$location',
    'logger',
    '$scope',
    '$modal',
    'sharedProperties',
    '$cookies',
    '$route',
    function(
      $http,
      $log,
      $location,
      logger,
      $scope,
      $modal,
      sharedProperties,
      $cookies,
      $route
    ) {
      $scope.notify = function(type, message) {
        switch (type) {
          case 'info':
            logger.log(
              "Heads up! This alert needs your attention, but it's not super important."
            )
            break
          case 'success':
            logger.logSuccess(message)
            break
          case 'warning':
            logger.logWarning(
              "Warning! Best check yo self, you're not looking too good."
            )
            break
          case 'error':
            logger.logError(message)
        }
      }

      let passwordToken = $route.current.params.token
      $scope.loggedInLawyer = {
        first_Name: $cookies.firstName,
      }
      $scope.showClass = ''
      $scope.hideDropDown = function() {
        $scope.showClass = ''
      }

      $scope.showDropDown = function() {
        if ($scope.showClass === '') {
          $scope.showClass = 'show'
        } else {
          $scope.showClass = ''
        }
      }

      $scope.isAdmin = false
      $scope.notApproved = false
      $scope.newUser = false
      $scope.showProfileNavBar = false
      if ($location.url() === '/change-password') {
        $http
          .post('/api/fetch-current-lawyer-refer', {
            contentType: 'application/json',
          })
          .then(function({data, status, headers, config}) {
            $scope.loggedInLawyer = data
            if (
              $scope.loggedInLawyer.user.refUserTypeUserTypeID === 1 ||
              $scope.loggedInLawyer.user.refUserTypeUserTypeID === 7
            ) {
              $scope.isAdmin = true
              $scope.loggedInLawyer.user.first_Name = $cookies.firstName
            } else if (
              $scope.loggedInLawyer.user.refUserTypeUserTypeID === 2 &&
              $scope.loggedInLawyer.lawyer.lawyer_Status !== 'Approved'
            ) {
              if (
                $scope.loggedInLawyer.lawyer.lawyer_Status ===
                  'Pending Approval' ||
                $scope.loggedInLawyer.lawyer.lawyer_Status === 'NewUser'
              ) {
                $scope.newUser = true
                $scope.notApproved = true
              } else if (
                $scope.loggedInLawyer.lawyer.lawyer_Status === 'locked'
              ) {
                $scope.newUser = false
                $scope.notApproved = false
              } else {
                $scope.notApproved = true
              }
            } else {
              $scope.showProfileNavBar = true
            }
          })
      }

      this.userPass = ''
      this.userConfirmPass = ''
      this.userOldPass = ''
      this.password = {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      }
      this.updatePassword = function() {
        var message
        if (this.password.newPassword === this.password.confirmNewPassword) {
          if ($location.url() === '/change-password') {
            $http
              .post('/api/change-password', {
                userPass: this.password,
              })
              .then(
                function({data, status, headers, config}) {
                  var message
                  message = 'Password updated successfully'
                  $scope.notify('success', message)
                  if (
                    $scope.loggedInLawyer.user.refUserTypeUserTypeID === 1 ||
                    $scope.loggedInLawyer.user.refUserTypeUserTypeID === 7
                  ) {
                    $location.url('/admin/admin-listings')
                  } else if (
                    $scope.loggedInLawyer.lawyer.lawyer_Status === 'Approved'
                  ) {
                    $location.url('/user-profile')
                  } else {
                    $location.url('/profile')
                  }
                },
                function(error) {
                  $scope.notify('error', 'Your current password is incorrect.')
                }
              )
          } else if (isResetPasswordPage($location.url())) {
            $http
              .post('/api/updatePassword', {
                userPass: this.password,
                passwordToken: passwordToken,
              })
              .then(
                function({data, status, headers, config}) {
                  var message
                  message = 'Password updated successfully'
                  $scope.notify('success', message)
                  $location.url('/signin')
                },
                function(error) {}
              )
          }
        } else {
          message = 'Passwords do not match'
          $scope.notify('error', message)
        }
      }

      $scope.logOut = function() {
        sharedProperties.logOut()
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/change-password/ResetPassCtrl.js